<p-toast></p-toast>
<p-confirmDialog header="Confirmation" appendTo="body" styleClass="confirm-dialog"></p-confirmDialog>
<!--Filter Code  -->
<div class="col-lg-12 nopadding">
  <app-filter-panel pageName="CAIS-Exception" [GridColumns]="GridColumns" [DefaultFilterArray]="DefaultFilterArray"
    (FilterEvent)="FilterApplyFilterEvent($event)" (FilterEventClearCode)="FilterEventClearCode($event)">
  </app-filter-panel>
</div>
<!-- Record Type Filter -->
<div class="col-lg-12 noLineHeight nopadding">
  <div class="ui-widget-header-1 nopadding">
    <ul class="nopadding">
      <label for="CLIENT">
        <p-button [id]="'CLIENT'" type="button"  
          [ngClass]="activeRecordType === 'CLIENT' ? 'button btn-xs active-symbol cais-symbol-button' : 'button btn-xs non-active-symbol'"
          (click)="getRecordTypeData('CLIENT');">
          CLIENT
        </p-button>
      </label>
      <label for="FINRA">
        <p-button [id]="'FINRA'" type="button" 
          [ngClass]="activeRecordType === 'FINRA' ? 'button btn-xs active-symbol cais-symbol-button' : 'button btn-xs non-active-symbol'"
          (click)="getRecordTypeData('FINRA');">
          FINRA
        </p-button>
      </label>
    </ul>
  </div>
</div>
<!-- Entity Type Filter -->
<div class="col-lg-12 noLineHeight nopadding">
  <div class="ui-widget-header-1 nopadding">
    <ul class="nopadding">
      @for(entity of quickFilterEntityTypeArray; track entity.label + '-'+ $index) { 
      <label for="entityTypeFilter">
        <p-button [id]="entity.label" type="button"  
          [ngClass]="quickFilterEntityType === entity.label ? 'button btn-xs active-symbol cais-symbol-button' : 'button btn-xs non-active-symbol'"
          (click)="applyEntityFilter(entity.value)">
          {{entity.label}}
        </p-button>
      </label>
      }
    </ul>
    <ul class="nopadding">
      @for(reportDate of quickFilterDateArray; track reportDate.label + '-'+ $index) { 
      <label for="reportDateLabel">
        <p-button [id]="reportDate.label" type="button"  
          [ngClass]="quickFilterDate === reportDate.label ? 'button btn-xs active-symbol cais-symbol-button' : 'button btn-xs non-active-symbol'"
          (click)="applyDateFilter(reportDate.value)">
          {{reportDate.label}}
        </p-button>
      </label>
      }
    </ul>
  </div>
</div>

<!-- Filter Quick Fields Panel Code -->
<div class="col-lg-12 nopadding">
  <app-symbol-panel [CodeArray]="codesArray"
    [ActiveExceptionCode]="ActiveExceptionCode"
    (ActiveCodeEvent)="setActiveCodeEvent($event)">
  </app-symbol-panel>
</div>


<!-- Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults){
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
  }
  <p-table alwaysShowPaginator="true" paginatorPosition="both" showCurrentPageReport="true"
    [value]="dataset" [columns]="cols" [resizableColumns]="true" columnResizeMode="expand" [totalRecords]="totalRecords"
    [(selection)]="this.dataService.roeSelectedRecords" [paginator]="true" selectionMode="multiple" appendTo="body"
    (onPage)="changePage($event)" (onSort)="sort($event)" sortMode="multiple"
    [rows]="constantService.DEFAULT_ROWSIZE" [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS"
    [rowsPerPageOptions]="rowsPerPageOptions" [lazy]="true" #dt styleClass = "cais-exception-table" [scrollable]="true" 
    scrollHeight="60vh">
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          {{tbldatamsg}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th id="tablecheckbox" style="width: 3em">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        @for(col of columns; track col.field + '-'+ $index) {
          @if(!col?.isoptionalfields){
            <th id="colHeader" pResizableColumn [pSortableColumn]="col.field"
              [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
              {{col.header}}
              @if((col.header | lowercase) !== 'action'){
                <p-sortIcon [field]="col.field"></p-sortIcon>
              }
            </th>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex"
        [ngClass]="(row['modifiedFlag'] | lowercase)== 'u' ? 'ui-widget-updated-row' : (row['modifiedFlag'] | lowercase) == 'd' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row'">
        <td style="width: 3em;padding-left: 6px !important;">
          @if(row['status'] != 'SUBMITTED'  && row['status'] != 'GENERATED'){
          <span>
            <p-tableCheckbox [id]="'checkbox'+ rowIndex" [value]="row"></p-tableCheckbox>
          </span>
          }
        </td>
        @for(col of columns; track col.field + '-'+ $index) {
          @if(!col?.isoptionalfields){
            <td class="ui-resizable-column"
              [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay' : ''"
              [matTooltip]="(['FirmDesignatedID'].includes(col.header) ? row['receivedFDID'] : '')" [matTooltipPosition]="'after'">
              <!-- set String -->
              @if(!['Action'].includes(col.header)){
              <span>
                {{row[col.field]}}
              </span>
              }
              @if(col.header === 'Action'){
              <span>
                @if(row['firmDesignatedID'] != null && row['firmDesignatedID'] != ''){
                <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" matTooltipPosition="above"
                  appendTo="body" icon="fa fa-xxx fa-eye" (click)="onRowSelect('View',rowIndex,row);"></p-button>
                }
                @if(skipEditActionFailureCode(row['failureCode']) && checkFailureCode(row['failureCode']) && row['firmDesignatedID'] != null && row['firmDesignatedID'] != '' && (row['customerRecordID'] != 0 || row['source'] != 'FINRA')){
                <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Edit" matTooltipPosition="above"
                  appendTo="body" icon="fa fa-fw fa-edit" (click)="onRowSelect('Edit',rowIndex,row);"></p-button>
                }
                @if(row['source'] == 'FINRA' || (row['firmDesignatedID'] != null && row['firmDesignatedID'] != '')){
                <p-button [id]="'AuditBtn'+row['id']" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Audit-Trail" matTooltipPosition="above"
                  appendTo="body" icon="fa fa-fw fa-list" (click)="onRowSelect('AuditTrail',rowIndex,row)"></p-button>
                }
                @if(row['source'] == 'FINRA' && checkFailureCodeForDelete(row['failureCode'])){
                <span>
                  @if(row[col.field] != 'D' && row['status'] != 'GENERATED'){
                  <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" [matTooltipShowDelay]="1000"
                  matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-trash"
                  [id]="'delete'+ rowIndex" (click)="onDelete(rowIndex,row);"></p-button>
                  }
                  @if(row[col.field] == 'D' && row['status'] != 'SUBMITTED'  && row['status'] != 'GENERATED'){
                  <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Restore Deleted" [matTooltipShowDelay]="1000"
                  matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-undo"
                  [id]="'restore'+ rowIndex" (click)="onRestoreDeleted(rowIndex,row);"></p-button>
                  }
                </span>
                }
                </span>
              }
            </td>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <app-export-to-csv [gridColumns]="CAISExceptionCSVGridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
      Total Records: {{dataset.length == 0? 0 : totalRecords}}
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <!-- Page No : {{pageNumber }} -->
      Showing {{dataset.length == 0? 0 : startLimit + 1}} to {{dataset.length
      < rowcount ? dataset.length < startLimit ? endLimit : dataset.length : endLimit}} entries </ng-template>
  </p-table>
  <br>
  <br>
</div>

@if(caisExceptionServiceService.isCaisView){
<app-view [rowDataforDialog] ="rowDataforDialog"
[screenType]="screenType" ></app-view>
}
@if(caisExceptionServiceService.isCaisEdit){
<app-edit [screenType]="screenType" ></app-edit>
}

<!-- CAIS Audit Trail History -->
 @if(isAuditTrail){
<app-cais-audit-trail-dialog 
  id="CAIS-Exception-audit-trail" 
  (closeEventDialog)="isAuditTrail = false"
  [SelectedRow]="rowDataforDialog"
  [isAuditTrailOpen]="isAuditTrail"
  [pageName]="ApplicationName">
</app-cais-audit-trail-dialog>
 }